import React from 'react';

export const NavHeader = ({ showNavigationLinks }) => {
  return (
    <nav className="page-header-nav clearfix">
      <span className="logo" href="#"><i>
        Barclays Personal Loan</i></span>
      <span className="brand text-white font-weight-light" href="#">
        <strong>
          Barclays
        </strong> Personal Loan
      </span>
      {
        showNavigationLinks &&
        <ul>
          <li>
            <a className="text-white" data-track="topNav" id="topOfPage" href="/applicationcenter">Check My Application</a>
          </li>
          <li>
            <a className="text-white" data-track="topNav" href="https://loans.barclaysus.com/pages/home">Log in</a>
          </li>
        </ul>
      }
    </nav>
  );
};

export default NavHeader;
